// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"35":"f31aec94","212":"d0deef33"}[chunkId] || chunkId) + "." + {"35":"d228b2996bbb0d2d","36":"e935ca1f9bc2d737","85":"e667b0ace58d48b3","193":"a04f684e4ac0b9f8","212":"9a6051c051181d43","228":"778bae214c45733d","305":"5433b967c08ab7c6","709":"2f4bc70a65fac0e6","795":"25767f4342178037"}[chunkId] + ".js";
};